/**
 * auth/msalConfig.js — MSAL (Microsoft Authentication Library) configuration.
 *
 * VITE_AZURE_CLIENT_ID and VITE_AZURE_TENANT_ID are injected at build time
 * from environment variables (see .env.example).
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin + '/auth/callback',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

/**
 * Scopes requested during login.
 * The app-specific scope ensures the access token has aud=<client_id>,
 * which the backend validates. openid/profile/email are implicitly included.
 */
export const loginRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`],
}
